import { useMemo, FunctionComponent } from "react"
import cn from "classnames"

import { OfferedService, Psychologist } from "utils/interfaces"
import { Box, Text } from "ui-kit/components-branded/index"
import { ProfileLink } from "app/AppRouter/links"
import { Analytics } from "utils/analytics"
import { Discount, Price as PriceTemplate } from "components/PriceTemplate"
import { HelpTooltip } from "components/HelpTooltip"
import { Classes, Header } from "modules/SelectionOfPsychologists/components/Card/Header"
import { PublicServicePrice } from "modules/SelectionOfPsychologists/components/Card/PublicServicePrice"
import { getPublicServices } from "utils/helpers/psychologistUtil"
import { useSearchParams } from "utils/customHooks"
import { APP_STATUSES } from "utils/AppStatusContext"

export const ProfileCard: FunctionComponent<{
    psy: Psychologist
    index: string
    className?: string
    from: Partial<APP_STATUSES>
    header?: {
        classes: Classes
    }
    fromLink?: string
}> = ({ psy, className, from, header, fromLink }) => {
    const searchParams = useSearchParams()
    const resultsKey = useMemo(() => searchParams.get("results_key"), [])
    const publicServices = getPublicServices(psy.offered_services)
    return (
        <Box
            className={cn(
                "is-flex is-flex-direction-column is-justify-content-space-between p-3 profile-card__card",
                className
            )}
        >
            <Header
                psy={psy}
                from={from}
                showAvailability={false}
                classes={{
                    title: cn("profile-card__title", "blm-h4", header?.classes?.title),
                    labels: "profile-card__labels",
                    header: cn("profile-card__header", header?.classes?.header),
                    mainInfo: cn("profile-card__main-info", header?.classes?.mainInfo),
                    specialization: cn(
                        "profile-card__specialization",
                        header?.classes?.specialization
                    ),
                    additionalInfo: cn(header?.classes?.additionalInfo),
                }}
                onClick={() => {
                    Analytics.similar_psy_profile_clicked()
                }}
                target="_blank"
            />
            <div>
                <hr className="my-3 profile-card__divider" />
                {publicServices.length > 0 && (
                    <Text isAccent className="is-block mgb-3">
                        <div>
                            <Discount
                                className="profile-card__discount price-and-discount__discount-strikethrough"
                                psy={psy}
                            />
                        </div>
                        <div className="is-flex is-align-items-center">
                            <PriceTemplate psy={psy} className="profile-card__price" />
                            <span className="ml-2">
                                <HelpTooltip
                                    placement="bottom"
                                    overlay={
                                        <>
                                            {publicServices.map((service: OfferedService) => (
                                                <PublicServicePrice
                                                    key={service.id}
                                                    psy={psy}
                                                    service={service}
                                                />
                                            ))}
                                        </>
                                    }
                                />
                            </span>
                        </div>
                    </Text>
                )}
                <ProfileLink
                    profileUrl={psy.profile_url}
                    className="border-radius-5 py-3 px-5 text-center b-button button--regular w-100 survey-results-card__more-details-button transition-ease"
                    from={from}
                    fromLink={fromLink}
                    resultsKey={resultsKey}
                    onClick={() => {
                        Analytics.similar_psy_profile_clicked()
                    }}
                    target="_blank"
                >
                    Посмотреть
                </ProfileLink>
            </div>
        </Box>
    )
}
